// 261025 3d2 (K13) — hàm THUẦN của cổng ② «máy chấm khung xương» trong chuỗi truyện mới: dòng chữ ở dải STOP 1, danh sách «Cần bạn xem» ở màn ②, nhãn chiều chấm.
// KHÔNG import antd / react (jest của react-scripts không load được antd v6). `.tsx` chỉ vẽ.
import type { SkeletonGateView, SkeletonGateUnresolved } from '../../../types/adaptationWorkbench';

/** Chiều chấm → chữ người đọc (chép từ BE `SKELETON_DIMENSIONS`). Mã lạ ⇒ câu chung, KHÔNG lộ mã thô. */
export const SKELETON_DIMENSION_LABEL: Record<string, string> = {
  lead_character_coverage: 'Nhân vật chính còn thiếu',
  beat_source_grounding: 'Cao trào không bám nguyên tác',
  identity_link_fit: 'Liên kết nhân vật chưa khớp',
  beat_coverage: 'Cao trào chưa đủ',
  arc_grounding: 'Mạch nhân vật chưa bám nguyên tác',
  adaptation_fit: 'Chuyển thể chưa khớp nguyên tác',
  // 3g (Q2): đích lint của vòng tự sửa ② (unit `lint`, dimension = mã lint BE) — nhãn riêng để khỏi hiện «Điểm cần xem» chung.
  CUT_REQUIRED: 'Chưa nêu đã cắt gì',
  KEEP_REQUIRED: 'Chưa nêu giữ gì',
  NO_LEAD: 'Chưa có nhân vật chính',
};
export const skeletonDimensionLabel = (d: string | null | undefined): string => (d && SKELETON_DIMENSION_LABEL[d]) || 'Điểm cần xem';

export const SKELETON_GATE_ERROR_LINE = 'Máy chưa chấm được khung xương — bạn tự đọc lại trước khi duyệt';
export const SKELETON_GATE_STALE_LINE = 'Kết quả chấm đã cũ (bạn đã sửa khung sau lần chấm)';
export const SKELETON_AUTO_FIX_ORIGIN_LABEL = 'Máy sửa (chấm khung)';

/** Dòng ở dải STOP 1 (`wait_skeleton`). Chưa chấm (MISSING) / không có view ⇒ không dòng nào (BE cũ, chuỗi cũ, tắt cổng). */
export const nsSkeletonGateLines = (view: SkeletonGateView | null | undefined): string[] => {
  if (!view || view.state === 'MISSING') return [];
  if (view.state === 'STALE') return [SKELETON_GATE_STALE_LINE];
  if (view.stopReason === 'GATE_ERROR') return [SKELETON_GATE_ERROR_LINE];
  const left = view.unresolved.length;
  return [`Máy đã chấm khung xương: tự sửa ${view.fixedCount} chỗ · còn ${left} việc bạn có thể xem`];
};

export type SkeletonUnitKind = 'outline' | 'character' | 'beat' | 'adaptation' | 'unknown';
export interface SkeletonUnitRef { kind: SkeletonUnitKind; id?: string }

/** `unit` của mục chấm → loại + id thực thể (để «Đi tới»). `outline`/`adaptation:*` ⇒ ở lại tab Cấu trúc chuyển thể. */
export const parseSkeletonUnit = (unit: string | null | undefined): SkeletonUnitRef => {
  const u = String(unit ?? '');
  if (u === 'outline') return { kind: 'outline' };
  if (u.startsWith('adaptation:')) return { kind: 'adaptation' };
  if (u.startsWith('char:') && u.length > 5) return { kind: 'character', id: u.slice(5) };
  if (u.startsWith('beat:') && u.length > 5) return { kind: 'beat', id: u.slice(5) };
  return { kind: 'unknown' };
};

export interface SkeletonNeedsYouItem {
  key: string;
  dimensionLabel: string;
  problem: string;
  /** Trích dẫn (gập) — chỉ phần đã xác minh; rỗng ⇒ không hiện khối gập. */
  quotes: string[];
  unit: SkeletonUnitRef;
}

const quotesOf = (u: SkeletonGateUnresolved): string[] =>
  (Array.isArray(u.evidence) ? u.evidence : [])
    .map((e) => (e && typeof e === 'object' ? String((e as { quote?: unknown }).quote ?? '').trim() : ''))
    .filter(Boolean);

/**
 * Danh sách «Cần bạn xem» ở màn ②: chỉ khi kết quả còn MỚI (FRESH). STALE ⇒ ẩn danh sách cũ (chỉ một dòng xám), MISSING ⇒ không có.
 * Không ảnh hưởng `canApprove` — đây chỉ là gợi ý đọc.
 */
export const skeletonNeedsYouView = (view: SkeletonGateView | null | undefined, opts: { approved?: boolean } = {}): { items: SkeletonNeedsYouItem[]; greyLine: string | null } => {
  if (!view || view.state === 'MISSING') return { items: [], greyLine: null };
  // 3h1 (H11b): khung ĐÃ duyệt ⇒ chuỗi đã đi qua, máy ghi bản địa hoá làm đổi băm ⇒ «bạn đã sửa khung sau lần chấm» vừa vô nghĩa vừa sai chủ ngữ.
  if (view.state === 'STALE') return { items: [], greyLine: opts.approved ? null : SKELETON_GATE_STALE_LINE };
  if (view.stopReason === 'GATE_ERROR') return { items: [], greyLine: SKELETON_GATE_ERROR_LINE };
  return {
    greyLine: null,
    items: view.unresolved.map((u, i) => ({
      key: `${u.unit}-${u.dimension}-${i}`, dimensionLabel: skeletonDimensionLabel(u.dimension), problem: String(u.problem ?? ''), quotes: quotesOf(u), unit: parseSkeletonUnit(u.unit),
    })),
  };
};
